import axiosPrivate  from "../axiosPrivate";
import { useMutation } from "@tanstack/react-query";

export const useExchangeRate = () =>
  useMutation({
    mutationFn: async (payload) => {
      const res = await axiosPrivate.post("currencies/exchange/rate", payload);
      return res.data;
    },
  });